// TelcoTrack - Stepper Component (P1 #13)
// Lightweight visual progress indicator for multi-step flows (GeoJSON import wizard: File →
// Cíl/Mapování → Import → Výsledek). Presentation-only — the parent component still owns
// step state/validation; this just renders "where am I" with an accessible list marker.

import { Component, Input } from '@angular/core';

export interface StepperStep {
  id: string;
  label: string;
}

@Component({
  selector: 'app-stepper',
  template: `
    <ol class="tt-stepper" [attr.aria-label]="ariaLabel || null">
      <li
        *ngFor="let step of steps; let i = index; trackBy: trackStep"
        class="tt-stepper__item"
        [class.tt-stepper__item--done]="stepState(step, i) === 'done'"
        [class.tt-stepper__item--active]="stepState(step, i) === 'active'"
        [attr.aria-current]="stepState(step, i) === 'active' ? 'step' : null"
      >
        <span class="tt-stepper__marker" aria-hidden="true">
          <svg *ngIf="stepState(step, i) === 'done'" class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
          </svg>
          <span *ngIf="stepState(step, i) !== 'done'">{{ i + 1 }}</span>
        </span>
        <span class="tt-stepper__label">{{ step.label }}</span>
      </li>
    </ol>
  `,
})
export class StepperComponent {
  @Input() steps: StepperStep[] = [];
  @Input() activeId = '';
  @Input() ariaLabel = 'Průběh';

  trackStep(_index: number, step: StepperStep): string {
    return step.id;
  }

  stepState(step: StepperStep, index: number): 'done' | 'active' | 'upcoming' {
    const activeIndex = this.steps.findIndex((s) => s.id === this.activeId);
    if (activeIndex === -1) return 'upcoming';
    if (index < activeIndex) return 'done';
    if (index === activeIndex) return 'active';
    return 'upcoming';
  }
}
